export async function index({commit}) {

  const {errResponse, data: responseData} = await this.$adminRepositories.papers.index();

  if (!errResponse && responseData.success) {
    const relatedPapers = responseData.data.map((element) => {
      return {
        id : element.id,
        paperable_id: element.id,
        title: element.title,
        name: element.title,
        paperable_type: element.model_class,
        id_encrypt: element.id_encrypt ?? '',
        application_user: element.hasOwnProperty('application_user') && element.application_user 
          ? element.application_user[0] : [],
      }
    });
    return commit('setPapers', relatedPapers);
  }

  return [];
}
